import React from 'react';
import LoyaltyLevel from './LoyaltyLevel';
import ProfileCompletion from './ProfileCompletion';
import LoyaltyCard from './LoyaltyCard';
import LoyaltyPages from './LoyaltyPages';
import LoyaltyBenefits from './LoyaltyBenefits';
import Preferences from './Preferences';
import GreetingUser from './GreetingUser';

const Sidebar = ({
  member, 
  loy3ProfileData, 
  membershipData,
  userData,
  registrationInfo
}) => {

  return (
    <div>
      <GreetingUser />
      <br />
      <ProfileCompletion
      completedPercentage = {member && member.completedProfile}
      member={member}
      />
      <br/>
      <LoyaltyCard />
      <br/>
      <LoyaltyLevel
        level={membershipData && membershipData.membershipInfo.memberShipName}
        nights={membershipData && membershipData.membershipInfo.noOfNights}
        bookings_total={membershipData && membershipData.membershipInfo.noOfStays}
        max_nights_level={membershipData && membershipData.membershipInfo.totalNightsToUpgrade}
      />
      <br/>
      <LoyaltyPages />
      <br/>
      <LoyaltyBenefits />
      <br />
      <Preferences 
        user={userData} 
        registrationInfo={registrationInfo}
        />
    </div>
  );
};

export default Sidebar;
